export default __webpack_public_path__ + "img/EF.5f3c4acfb7fdc3e963c42a44e8a84f13.jpg";